var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 22,
    viewBox: "0 0 17 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4668 1C4.34859 1 1 4.34859 1 8.4668C1 11.4613 2.81341 14.6534 4.58785 17.1376C6.36229 19.6218 8.13781 21.3972 8.13781 21.3972C8.22532 21.4846 8.34396 21.5337 8.46766 21.5337C8.59136 21.5337 8.70999 21.4846 8.79751 21.3972C8.79751 21.3972 10.573 19.6218 12.3475 17.1376C14.1219 14.6534 15.9336 11.4613 15.9336 8.4668C15.9336 4.34859 12.585 1 8.4668 1ZM8.4668 1.93356C12.0806 1.93356 15 4.853 15 8.4668C15 11.0724 13.3134 14.1792 11.5879 16.595C10.0271 18.78 8.75058 20.0517 8.4668 20.3413C8.1825 20.0512 6.90784 18.7796 5.34745 16.595C3.62188 14.1792 1.93356 11.0724 1.93356 8.4668C1.93357 4.853 4.853 1.93356 8.4668 1.93356Z",
    fill: "#EDFEFF",
    stroke: "#EDFEFF",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46668 5.19922C6.66808 5.19922 5.20093 6.66809 5.20093 8.4667C5.20093 10.2653 6.66808 11.7342 8.46668 11.7342C10.2653 11.7342 11.7342 10.2653 11.7342 8.4667C11.7342 6.66809 10.2653 5.19922 8.46668 5.19922ZM8.46668 6.13278C9.76088 6.13278 10.8006 7.1725 10.8006 8.4667C10.8006 9.76089 9.76088 10.8006 8.46668 10.8006C7.17249 10.8006 6.13449 9.76089 6.13449 8.4667C6.13449 7.1725 7.17249 6.13278 8.46668 6.13278Z",
    fill: "#EDFEFF",
    stroke: "#EDFEFF",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/mapMarker.0f6aab248e7ad0447760a92f97b757ba.svg";
export { ForwardRef as ReactComponent };